import { render } from "./WhatsAppList.vue?vue&type=template&id=34b8ed00&scoped=true"
import script from "./WhatsAppList.vue?vue&type=script&lang=js"
export * from "./WhatsAppList.vue?vue&type=script&lang=js"

import "./WhatsAppList.vue?vue&type=style&index=0&id=34b8ed00&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b8ed00"]])

export default __exports__